
export const SET_SIDEBAR_GROUP = 'app/ui/SET_SIDEBAR_GROUP';
export const SET_SIDEBAR_FILTER = 'app/ui/SET_SIDEBAR_FILTER';
export const SET_SIDEBAR_LIST_STATE = 'app/ui/SET_SIDEBAR_LIST_STATE';

export const SET_PAGE_TITLE = 'app/ui/SET_PAGE_TITLE';

export const SET_MOBILE_NAV = 'app/ui/SET_MOBILE_NAV';

export const SET_UI_KEY_VALUE = 'app/ui/SET_UI_KEY_VALUE';
export const SET_IS_MODAL_OPEN_VALUE = 'app/ui/SET_IS_MODAL_OPEN_VALUE';
